import React from 'react';
import { siteContent } from '../data/mock';

const DifferentiationSection = () => {
  const { differentiation } = siteContent;

  return (
    <section className="differentiation-section section-padding" data-testid="differentiation-section" data-reveal="fade">
      <div className="container">
        <h2 className="section-title-center" data-testid="differentiation-title">{differentiation.title}</h2>
        <p className="differentiation-intro">{differentiation.introduction}</p>

        <div className="differentiation-list">
          {differentiation.comparisons.map((item, index) => (
            <div key={index} className="differentiation-item" data-testid={`differentiation-item-${index}`}>
              <div className="differentiation-item-header">
                <h3 className="differentiation-category">{item.category}</h3>
              </div>
              <p className="differentiation-description">{item.description}</p>
              <p className="differentiation-contrast">{item.contrast}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentiationSection;
